var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ItpPage",
    {
      attrs: {
        "no-primary-button": "",
        closeButtonText: _vm._f("gettext")("Close"),
        size: _vm.size,
        header: _vm.documentTitle,
        loaded: _vm.loaded,
        noShow: !_vm.loaded,
        modal: _vm.modal,
        "itp-cname": "ContractService",
        modalBindings: _vm.b_7315092382398562_modalBindings
      },
      on: {
        close: function($event) {
          return _vm.evh_7315092382398562_close($event, {})
        }
      }
    },
    [
      _vm.loaded
        ? _c("UcHeader", {
            attrs: {
              slot: "header",
              card: !_vm.modal,
              modal: _vm.modal,
              title: _vm.documentTitle
            },
            on: {
              close: function($event) {
                return _vm.evh_2248226175642056_close($event, {})
              }
            },
            slot: "header"
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded
        ? _c(
            "UcBody",
            {
              attrs: {
                card: !_vm.modal,
                modal: _vm.modal,
                stretch: "",
                "no-padding": "",
                col: _vm.b_5962862420439144_col,
                "full-height": ""
              }
            },
            [
              _c(
                "b-tabs",
                {
                  staticClass:
                    "h-100 d-flex flex-column tabs-material overflow-hidden",
                  attrs: {
                    "nav-class": "material px-3",
                    contentClass: "flex-shrink-1 overflow-hidden"
                  }
                },
                [
                  _c(
                    "b-tab",
                    {
                      staticClass:
                        "container-fluid h-100 pt-4 px-5 overflow-auto",
                      attrs: {
                        title: _vm._f("pgettext")("General", "ContractService")
                      }
                    },
                    [
                      _c(
                        "ItpForm",
                        {
                          ref: "mainForm",
                          staticClass: "row",
                          attrs: { id: _vm.formId, name: "contract" },
                          on: {
                            submit: function($event) {
                              return _vm.evh_7789867021953041_submit($event, {})
                            }
                          }
                        },
                        [
                          _c(
                            "ItpCol",
                            [
                              _c("FieldsetContractService", {
                                attrs: {
                                  item: _vm.item,
                                  readonly: _vm.isReadonly,
                                  labelAlign: _vm.labelAlign
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-tab",
                    {
                      staticClass:
                        "container-fluid h-100 pt-4 px-5 overflow-auto",
                      attrs: {
                        title: _vm._f("pgettext")("Fees", "ContractService")
                      }
                    },
                    [
                      _c("UCContractServiceFeesEditor", {
                        attrs: {
                          service: _vm.item,
                          readonly: _vm.isReadonly,
                          labelAlign: _vm.labelAlign
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded
        ? _c(
            "UcFooter",
            {
              attrs: { slot: "footer", card: !_vm.modal, modal: _vm.modal },
              slot: "footer"
            },
            [
              _c("ItpButton", {
                attrs: {
                  text: _vm._f("pgettext")("Save", "Button"),
                  type: "submit",
                  form: _vm.formId,
                  variant: "primary",
                  icon: "fa-save",
                  spinning: _vm.actions.save.isRunning
                }
              }),
              _vm._v(" "),
              _c("ItpButton", {
                attrs: { text: _vm._f("gettext")("Close"), variant: "default" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    $event.stopPropagation()
                    return _vm.evh_1419464017721962_clickPreventStop($event, {})
                  }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded ? _c("template", { slot: "footer" }) : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }